import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to, label = "Kembali", className = "" }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      onClick={handleBack}
      className={`inline-flex items-center gap-2 text-brand-500 font-semibold hover:text-brand-700 transition mb-4 ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="h-4 w-4" /> {label}
    </button>
  );
}
